import { QueryClient } from '@tanstack/react-query';

export const productVariantSelectBoxQueryKey = (
  supplierId?: string,
  productListId?: string,
  excludedIds?: (string | number)[],
): string[] => [
  'productVariantSelectBox',
  supplierId || '',
  productListId || '',
  excludedIds?.map(String).sort().join(',') ?? '',
];

export const invalidateProductVariantSelectBoxes = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: ['productVariantSelectBox'] });
